export default __webpack_public_path__ + "static/media/download-cloud-white.61ae4598.svg";